import type { BalanceType } from '../../../api/fetchers/userInfo/types';
import { roundNumber } from '../../../utils/number';

/**
 * Computes the balance and bonus based on the given parameters.
 *
 * @param {BalanceType} balance - The current balance of the user.
 * @param {number} totalBet - The total bet amount.
 * @param {number} decimals - The number of digits to round the balance and bonus to.
 * @param {boolean} isFreeBetPlaced - Boolean value which is true if free bet is placed.
 * @param {number} [winResult] - The win result amount. Optional.
 *
 * @returns {BalanceType} - The new balance and bonus.
 */
export const computeBalance = (
  balance: BalanceType,
  totalBet: number,
  decimals: number,
  isFreeBetPlaced: boolean,
  winResult?: number
): BalanceType => {
  if (isFreeBetPlaced) {
    return { ...balance };
  }
  const balanceDiff = balance.amount - totalBet;
  const bonusDiff = Math.min(balanceDiff, 0);
  const newBonus = balance.bonus + bonusDiff;
  let newBalance = Math.max(balanceDiff, 0);
  if (winResult) {
    newBalance += winResult;
  }
  return {
    ...balance,
    amount: roundNumber(newBalance, decimals),
    bonus: roundNumber(newBonus, decimals),
  };
};
